module.exports = __webpack_public_path__ + "img/sysmonitor.5dc571ca.svg";